export default {
  blogPosts: {},
  misundestoodMaterials: {},
  recyclingFundamentals: {},
  recycleRIGHT: {}
};
